import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu", "label", "from", "to"]
  static values = { placeholder: String }

  connect() {
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this)
    document.addEventListener("click", this.closeOnOutsideClick)
    this.update()
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick)
  }

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")
  }

  update() {
    const from = this.parseDate(this.fromTarget.value)
    const to = this.parseDate(this.toTarget.value)
    const hasRange = Boolean(from)

    if (from && to) {
      this.labelTarget.textContent = `${this.formatDate(from)} - ${this.formatDate(to)}`
    } else if (from) {
      this.labelTarget.textContent = this.formatDate(from)
    } else {
      this.labelTarget.textContent = this.placeholderValue
    }

    this.buttonTarget.classList.toggle("text-slate-400", !hasRange)
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
    }
  }

  parseDate(value) {
    if (!value) return null

    const [year, month, day] = value.split("-").map(Number)
    return new Date(year, month - 1, day)
  }

  formatDate(date) {
    const day = String(date.getDate()).padStart(2, "0")
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const year = date.getFullYear()

    return `${day}-${month}-${year}`
  }
}
